import { useParams, useNavigate } from 'react-router-dom';
import { ClassNavigation } from '../components/layout';

const FeedbackManagement = () => {
  const { classId } = useParams();
  const navigate = useNavigate();

  return (
    <div>
      <ClassNavigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">📝 Feedback Management</h1>
          <p className="text-gray-600">Configure and analyze feedback for your class</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            className="relative group cursor-pointer"
            onClick={() => navigate(`/dashboard/class/${classId}/feedback/setup`)}
          >
            <div className="absolute -inset-0.5 bg-gradient-to-r from-emerald-500 to-green-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
            <div className="relative bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-900">⚙️ Setup Feedback</h2>
                <div className="text-emerald-600">→</div>
              </div>
              <p className="text-gray-600 mb-4">
                Configure feedback collection settings, questions, and frequency.
              </p>
              <div className="flex items-center space-x-4 text-sm text-gray-500">
                <span>• Question Selection</span>
                <span>• Frequency Settings</span>
                <span>• Category Configuration</span>
              </div>
            </div>
          </div>

          <div
            className="relative group cursor-pointer"
            onClick={() => navigate(`/dashboard/class/${classId}/feedback/reports`)}
          >
            <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500 to-emerald-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
            <div className="relative bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-900">📊 View Reports</h2>
                <div className="text-blue-600">→</div>
              </div>
              <p className="text-gray-600 mb-4">
                Analyze feedback responses, trends, and generate insights.
              </p>
              <div className="flex items-center space-x-4 text-sm text-gray-500">
                <span>• Response Analysis</span>
                <span>• Trend Reports</span>
                <span>• Export Data</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackManagement;